import { useQuery } from 'react-apollo';
import { useSelector } from 'react-redux';

import { MeQuery } from '../../../../../../../../graphql/queries/account';

const useAccountLogo = () => {
  const authenticated = useSelector(({ auth }) => auth.authenticated);
  const { data: { me } = {} } = useQuery(MeQuery, {
    skip: !authenticated,
  });

  return {
    accountLogo: me?.logo_image ?? {},
  };
};

export default useAccountLogo;
